/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Publishdate1Inputs */

const en__field_publishdate1 = /** @type {(inputs: _Field_Publishdate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Publish Date`)
};

const de__field_publishdate1 = /** @type {(inputs: _Field_Publishdate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veröffentlichungs Datum`)
};

/**
* | output |
* | --- |
* | "Publish Date" |
*
* @param {_Field_Publishdate1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_publishdate1 = /** @type {((inputs?: _Field_Publishdate1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Publishdate1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_publishdate1(inputs)
	return de__field_publishdate1(inputs)
});
export { _field_publishdate1 as "_field_publishDate" }